import NAMESPACE from './types';

function selectRandomizedHeroHeader(state) {
    if (!state[NAMESPACE]) {
        return 1;
    }

    return state[NAMESPACE].randomHeroHeader;
}

export {
    selectRandomizedHeroHeader,
};
